(() => {
  function checkMedicationCode() {
    'ngInject';

    const directive = {
      restrict: 'A',
      require: 'ngModel',

      link(scope, element, attrs, ctrl) {
        ctrl.$parsers.unshift(function (viewValue) {
          const MedicationCode_REGEXP = /^[a-zA-Z0-9-]+$/;

          if (MedicationCode_REGEXP.test(viewValue)) {
            ctrl.$setValidity('trueCode', true);
            return viewValue;
          } else {
            ctrl.$setValidity('trueCode', false);
            return undefined;
          }
        });
      }

    };
    return directive;
  }

  angular.module('pims').directive('medicationCode', checkMedicationCode);
})();